/* eslint-disable import/named */
import '../styles/styles.css';

import { useState } from 'react';

import {
  Hydrate,
  QueryClientProvider,
  QueryClient,
} from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { AppProps } from 'next/app';
import Head from 'next/head';

import { wrapper } from '../lib/store';

function CustomApp({
  Component,
  pageProps: { session, ...pageProps },
}: AppProps) {
  const [queryClient] = useState(() => new QueryClient());

  return (
    <QueryClientProvider client={queryClient}>
      <Hydrate state={pageProps.dehydratedState}>
        <Head>
          <title>Dialox Workflow</title>
        </Head>
        <main>
          <Component {...pageProps} />
        </main>
      </Hydrate>
      {/* <ReactQueryDevtools initialIsOpen={false} /> */}
    </QueryClientProvider>
  );
}

export default wrapper.withRedux(CustomApp);
